import React from 'react'
import { Button } from '@arvoreeducacao/bonsai-ds'
import Cdn from 'utils/assets/Cdn'

import {
  ModalStyled,
  Container,
  Image,
  Title,
  TextResponsive,
  ButtonContainer
} from './ModalExplanation.styles'

import { useTranslation } from 'i18n'

const ModalExplanation = ({
  show,
  onClose,
  imageSrc,
  title,
  desktopText,
  mobileText
}) => {
  const { t } = useTranslation()

  return (
    <ModalStyled
      type="no-header"
      canCloseByXBtn={false}
      show={show}
      onClose={onClose}
    >
      <Container>
        <Image src={Cdn.getImageUrl(imageSrc)} />
        <Title size={5}>{title}</Title>
        <TextResponsive desktopText={desktopText} mobileText={mobileText} />
        <ButtonContainer>
          <Button primary onClick={() => onClose()}>
            {t('Entendi')}
          </Button>
        </ButtonContainer>
      </Container>
    </ModalStyled>
  )
}

export default ModalExplanation
